import Icon from "./icon.svg";

export default function Brand() {
  return (
    <img className="brand" src={Icon} alt="Animix" width="558" height="248" />
  );
}
